<template>
  <div class="automation-trigger-settings">
    <p>
      {{ t('automations-form-triggers_config-custom_event_without_order-description') }}
    </p>

    <div class="field">
      <label
        :class="{ label: true, 'label-danger': !isFieldValid('matchType') }"
        >{{ t('automations-form-triggers_config-custom_event_without_order-match_label') }}
      </label>
      <select v-model="matchType" class="form-control">
        <option value="exact">
          {{ t('automations-form-triggers_config-custom_event_without_order-match_options-exact') }}
        </option>
        <option value="starts_with">
          {{ t('automations-form-triggers_config-custom_event_without_order-match_options-starts_with') }}
        </option>
        <option value="contains">
          {{ t('automations-form-triggers_config-custom_event_without_order-match_options-contains') }}
        </option>
      </select>
    </div>

    <div class="field" v-if="matchType === 'exact'">
      <label
        :class="{ label: true, 'label-danger': !isFieldValid('customEventId') }"
        >{{ t('automations-form-triggers_config-custom_event_without_order-event_label') }}
      </label>
      <kv-search-select
        :placeholder="t('automations-form-triggers_config-custom_event_without_order-event_placeholder')"
        api-endpoint="custom-event/events"
        display-field="title"
        value-field="id"
        v-model="customEventId"
        icon-class="far fa-calendar"
        :min-search-length="1"
        @select="onEventSelected"
      />
    </div>

    <div class="field" v-else>
      <label
        :class="{ label: true, 'label-danger': !isFieldValid('eventTitle') }"
        >{{ t('automations-form-triggers_config-custom_event_without_order-title_label') }}
      </label>
      <input
        type="text"
        class="form-control"
        v-model="eventTitle"
        :placeholder="t('automations-form-triggers_config-custom_event_without_order-title_placeholder')"
      />
      <small>{{ t('automations-form-triggers_config-custom_event_without_order-title_help') }}</small>
    </div>

    <div class="field">
      <label
        :class="{ label: true, 'label-danger': !isFieldValid('delayAmount') }"
        >{{ t('automations-form-triggers_config-custom_event_without_order-time_label') }}
      </label>
      <input
        type="number"
        min="1"
        class="form-control"
        v-model.number="delayAmount"
        :placeholder="t('automations-form-triggers_config-custom_event_without_order-time_placeholder')"
      />
    </div>

    <div class="field">
      <label class="label">{{ t('automations-form-triggers_config-custom_event_without_order-unit_label') }}</label>
      <select v-model="delayUnit" class="form-control">
        <option value="days">{{ t('automations-form-triggers_config-custom_event_without_order-units-days') }}</option>
        <option value="hours">{{ t('automations-form-triggers_config-custom_event_without_order-units-hours') }}</option>
        <option value="minutes">{{ t('automations-form-triggers_config-custom_event_without_order-units-minutes') }}</option>
      </select>
    </div>

    <p class="cooldown-note">
      <small>{{ t('automations-form-triggers_config-custom_event_without_order-cooldown_note') }}</small>
    </p>
  </div>
</template>

<script>
import KvSearchSelect from "../../../components/ui/kv-search-select.vue";

export default {
  components: {
    KvSearchSelect,
  },
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    const value = this.value?.[0] || {};
    return {
      matchType: value.matchType || "exact",
      customEventId: value.customEventId || false,
      eventTitle: value.eventTitle || "",
      delayAmount: value.delayAmount ?? null,
      delayUnit: value.delayUnit || "days",
    };
  },
  computed: {
    errors() {
      const errors = {};
      if (!["exact", "starts_with", "contains"].includes(this.matchType)) {
        errors.matchType = "invalid";
      }
      if (this.matchType === "exact") {
        if (!this.customEventId) errors.customEventId = "required";
      } else {
        if (!this.eventTitle || !this.eventTitle.trim()) {
          errors.eventTitle = "required";
        }
      }
      if (!this.delayAmount || this.delayAmount <= 0) {
        errors.delayAmount = "required";
      }
      return errors;
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    isFieldValid(field) {
      return !Object.keys(this.errors).includes(field);
    },
    isValid() {
      return Object.keys(this.errors).length === 0;
    },
    onEventSelected(event) {
      this.customEventId = event.id;
    },
    emitChange() {
      const payload = [
        {
          matchType: this.matchType,
          customEventId: this.matchType === "exact" ? this.customEventId : null,
          eventTitle: this.matchType === "exact" ? "" : this.eventTitle,
          delayAmount: this.delayAmount,
          delayUnit: this.delayUnit,
        },
      ];
      if (JSON.stringify(payload) !== JSON.stringify(this.value)) {
        this.$emit("input", payload);
      }
    },
  },
  mounted() {
    this.emitChange();
  },
  watch: {
    matchType: "emitChange",
    customEventId: "emitChange",
    eventTitle: "emitChange",
    delayAmount: "emitChange",
    delayUnit: "emitChange",
    value: {
      deep: true,
      handler(newVal) {
        const val = newVal?.[0] || {};
        this.matchType = val.matchType || "exact";
        this.customEventId = val.customEventId || false;
        this.eventTitle = val.eventTitle || "";
        this.delayAmount = val.delayAmount ?? null;
        this.delayUnit = val.delayUnit || "days";
      },
    },
  },
};
</script>
